module.exports = __webpack_public_path__ + "static/DPF-Schwingungsdaempfer-3dec2912db13f1edfb173945f5b053b6.jpg";